import React from "react";
import Container from "../components/wrapper/container.wrapper";
import {Home} from "../modules/home";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";
import {RouteObject} from "react-router-dom";

export const HomeRouter = ():RouteObject => (
    {
        path: "/",
        element: <Container/>,
        errorElement: <ErrorBoundary hasError={true} />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
        ]
    }
)